"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _objectWithoutProperties2 = require("babel-runtime/helpers/objectWithoutProperties");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _tags = require("./tags");

var _reactRedux = require("react-redux");

var _lionSelectors = require("../selectors/lion-selectors");

var _lionSelectors2 = _interopRequireDefault(_lionSelectors);

var _propTypes = require("prop-types");

var _isPropValid = require("@emotion/is-prop-valid");

var _isPropValid2 = _interopRequireDefault(_isPropValid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var replacements = ownProps.replacements;
  // If no lionkey was supplied, use props.children as the translatedString. This makes lionkey optional
  // and you can use the same styled component for either lion or non-lion purposes.
  return {
    translatedString: ownProps.lionkey && _lionSelectors2.default.getLionTranslatedStringWithFallback(state, ownProps.lionkey, ownProps.fallback, replacements)
  };
};

var createLion = function createLion(Tag) {
  var LionComponent = _react2.default.memo(function (props) {
    var dispatch = props.dispatch,
        className = props.className,
        lionkey = props.lionkey,
        replacements = props.replacements,
        translatedString = props.translatedString,
        appResources = props.appResources,
        productResources = props.productResources,
        otherProps = (0, _objectWithoutProperties3.default)(props, ["dispatch", "className", "lionkey", "replacements", "translatedString", "appResources", "productResources"]);


    var propsToPassOn = (0, _keys2.default)(otherProps).filter(_isPropValid2.default).reduce(function (acc, prop) {
      acc[prop] = otherProps[prop];
      return acc;
    }, {});

    if (typeof translatedString !== "string") {
      return _react2.default.createElement(
        Tag,
        (0, _extends3.default)({ "data-qa": lionkey }, propsToPassOn, { className: className }),
        translatedString || props.children
      );
    }
    return _react2.default.createElement(Tag, (0, _extends3.default)({
      "data-qa": lionkey
    }, propsToPassOn, {
      className: className,
      dangerouslySetInnerHTML: {
        __html: translatedString
      }
    }));
  });
  var ConnectedComponent = (0, _reactRedux.connect)(mapStateToProps)(LionComponent);

  ConnectedComponent.propTypes = {
    className: _propTypes.PropTypes.string,
    fallback: _propTypes.PropTypes.string,
    replacements: _propTypes.PropTypes.objectOf(_propTypes.PropTypes.string)
  };

  return ConnectedComponent;
};

exports.default = _tags.tags.reduce(function (acc, tagName) {
  acc[tagName] = createLion(tagName);
  return acc;
}, {});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@rosetta/react-lion/dist/components/Lion.js
// module id = 898
// module chunks = 0